import React from "react";
import { Link } from "react-router-dom";
import AddBusi from "./AddBusi";

const AddBusiness = () => {
    return (
        <>
            {/* Breadcrumb */}
            <div className="breadcrumb-card">
                <h5>Business</h5>

                <ul className="breadcrumb">
                    <li>
                        <Link to="/dashboard/ecommerce/">
                            <i className="material-symbols-outlined">home</i>
                            Dashboard
                        </Link>
                    </li>
                    <li>CRM</li>
                    <li>Business</li>
                </ul>
            </div>

            <AddBusi />
        </>
    );
};

export default AddBusiness;